import { FC } from 'react';
import { CatalogDestinationContent } from './components/catalogDestination/catalogDestinationContent';

interface DestinationsProps {}

export const DestinationsV2: FC<DestinationsProps> = () => {
  return <CatalogDestinationContent />;
};
